export default {
  titlePage: `評価項目設定画面`,
  alertUnselectedUsers:
    "評価テーブルにまだ紐づけないユーザー数は{count}人です。",
  invalidTargetSettings: "評価目標設定がまだできなくて、再度確認してください。",
  processTargetStatus: {
    NEW: "未申請",
    WAIT_APPROVE: "申請中",
    APPROVED: "承認済み",
    REJECTED: "未申請",
  },
};
